'use client';
import { AllStreams } from './AllStreams';
import { StreamViewer } from './StreamViewer';
import { TableViewerLayout } from '@components/TableViewerLayout/TableViewerLayout';
import '../page.css';
import PropTypes from 'prop-types';

const StreamsPage = ({ userIsAdmin }) => {
  return (
    <TableViewerLayout
      tableTitle='All Streams'
      viewerTitle='Stream Viewer'
      tableSlot={<AllStreams userIsAdmin={userIsAdmin} />}
      viewerSlot={<StreamViewer userIsAdmin={userIsAdmin}/>}
    />
  );
};

export default StreamsPage;

StreamsPage.propTypes = {
  userIsAdmin: PropTypes.bool.isRequired,
};